import React from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import DashboardLayout from './layout/DashboardLayout'
import Overview from './components/Overview'
import ClientsListPage from '../Clients/pages/ClientsListPage'
import ClientDetailPage from '../Clients/pages/ClientDetailPage'
import ProjectsListPage from '../Projects/pages/ProjectsListPage'
import ProjectDetailPage from '../Projects/pages/ProjectDetailPage'
import ContractsListPage from '../Contracts/pages/ContractsListPage'
import ContractDetailPage from '../Contracts/pages/ContractDetailPage'
import SubscriptionsListPage from '../Subscriptions/pages/SubscriptionsListPage'
import SubscriptionDetailPage from '../Subscriptions/pages/SubscriptionDetailPage'

const Dashboard: React.FC = () => {
  return (
    <DashboardLayout>
      <Routes>
        <Route index element={<Overview />} />
        <Route path='clientes' element={<ClientsListPage />} />
        <Route path='clientes/:id' element={<ClientDetailPage />} />
        <Route path='aplicativos' element={<ProjectsListPage />} />
        <Route path='aplicativos/:id' element={<ProjectDetailPage />} />
        <Route path='contratos' element={<ContractsListPage />} />
        <Route path='contratos/:id' element={<ContractDetailPage />} />
        <Route path='assinaturas' element={<SubscriptionsListPage />} />
        <Route path='assinaturas/:id' element={<SubscriptionDetailPage />} />
        <Route path='*' element={<Navigate to='/dashboard' replace />} />
      </Routes>
    </DashboardLayout>
  )
}

export default Dashboard
